import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { IBirthplaceDictionary } from "src/webid/4.0/model/dictionaries/couchdb.birthplace.dictionary";

@Injectable()
export class BirthplaceDictionaryImpl extends IBirthplaceDictionary {
    searchByFullName(fullName: string): Observable<string> {
        return from([]);
    }

    searchByName(name: string): Observable<string> {
        return from([]);
    }
}
